
type Guid = string
type RetirementUnits = 'yearly' | 'monthly' | 'biWeekly' | 'weekly'
type SectionType = 'basic' | 'expenses' | 'pension' | 'retirement'

enum Gender {
  male = 'M',
  female = 'F',
  unidentified = 'U'
}

interface IRetirementExpense {
  beforeRetirement: number
  afterRetirement: number
  beforeRetirementUnits?: RetirementUnits
  afterRetirementUnits?: RetirementUnits
}

interface IIndvidualRetirementExpense {
  [guid: string]: IRetirementExpense
}

enum AutoOwnership {
  //Joint = '0', Member = '1', Spouse = '2'
  Joint = 0, Member = 1, Spouse = 2
}

export {
  AutoOwnership,
  Gender,
  IIndvidualRetirementExpense,
  IRetirementExpense,
  Guid,
  RetirementUnits,
  SectionType
}



// WEBPACK FOOTER //
// ./src/app/redux/Profile/model/interfaces.ts